/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Nothing_To_ApproveInputs */



/**
* | output |
* | --- |
* | "Nothing to approve" |
*
* @param {Partner_Admin_Commission_Nothing_To_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_nothing_to_approve = /** @type {((inputs?: Partner_Admin_Commission_Nothing_To_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Nothing_To_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nichts freizugeben")
	return /** @type {LocalizedString} */ ("Nothing to approve")
});